import styled from "styled-components";
import {  Divider } from "antd";
import { theme } from "../../../config";

export const ErrorMessage = styled.span`
  color: ${theme.colors.utilities.error};
`;

export const AccountStatusText = styled.div`
  color: #767676;
`;

export const AccountStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  font-size: 14px;
`;

export const StatusInfoWrapper = styled.div`
  display: flex;
  align-items: center;

  .ant-popover {
    width: 300px;
  }

  .ant-popover-message > .anticon {
    color: #ffc53d;
  }

  .ant-popover-buttons {
    .ant-btn {
      width: 70px;
      height: 30px;
    }

    .ant-btn-primary {
      background: #00918e;
      border-radius: 4px;
      border-color: #00918e;
    }
  }
`;

export const StatusInfoText = styled.div``;

export const PopconfirmTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const CreateSkillsLabel = styled.span`
  font-family: Orkney Bold;
  color: #111111;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  margin-right: 4px;
`;

export const CreateSkillsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
`;

export const SkillsDivider = styled(Divider)`
  border-top: 1px solid #BFBFBF;
  margin-top: 15px;
`;

export const RowWrapper = styled.div`
  padding: 0 31px 0 30px;
`;

export const RemoveButton = styled.button`
  border: none;
  color: #E15126;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  &:hover {
    text-decoration-line: underline;
  }
`;

export const AddSkillButton = styled.button`
  border: none;
  color: ${theme.colors.white};
  background-color: ${theme.colors.secondary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 7px 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
  margin-top: 16px;
  &:hover {
    background-color: ${theme.colors.secondary2};
  }
  &:active {
    background-color: ${theme.colors.secondary1};
  }
  img {
    margin-bottom: 3px;
    margin-right: 5px;
  }
  &:disabled {
    background: ${theme.colors.neutral.black5};
    color: ${theme.colors.primaryText};
    &:hover {
      background: ${theme.colors.neutral.black5};
      color: ${theme.colors.primaryText};
    }
    cursor: not-allowed;
  }
`;

export const RemoveButtonWrapper = styled.div`
  margin-top: 10px;
`;

export const InputTitle = styled.p`
  margin: 0;
  color: ${theme.colors.dark};
  position: absolute;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
  }
`;